import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import DatePickerField from '../../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { CasesGeneralClaimsProps } from './props';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';
import { useCasesGeneralClaims } from './hook';
import { formatParams } from '../../../../../../shared/utils/params';

export const CasesGeneralClaims = (props: CasesGeneralClaimsProps) => {
    const { formik, status } = useCasesGeneralClaims(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información del reclamo
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <DatePickerField
                    label="Fecha del evento"
                    name="dateEvent"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    touched={formik.touched.dateEvent}
                    errors={formik.errors.dateEvent?.toString()}
                    value={
                        formik.values.dateEvent
                            ? dayjs(formik.values.dateEvent)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'dateEvent',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <FieldSelect
                    data={formatParams(status)}
                    label="Estado"
                    name="status"
                    size="small"
                    required
                    touched={formik.touched.status}
                    errors={formik.errors.status}
                    value={formik.values.status as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <FieldText
                    label="Descripción de los hechos"
                    name="description"
                    size="small"
                    required
                    rows={6}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.description}
                    errors={formik.errors.description}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <FieldText
                    label="Observaciones"
                    name="observation"
                    size="small"
                    required
                    rows={6}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.observation}
                    errors={formik.errors.observation}
                    value={formik.values.observation}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <FieldText
                    label="Radicado de correspondencia"
                    name="correspondenceFiling"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.correspondenceFiling}
                    errors={formik.errors.correspondenceFiling}
                    value={formik.values.correspondenceFiling}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
